import { MIDDLE_OFFICE_BASE_PATH } from '../../constants/middleOfficeBasePath';

export const TWO_FACTOR_BASE_PATH = `${MIDDLE_OFFICE_BASE_PATH}/two-factor`;
